import { render, staticRenderFns } from "./VEmployer.vue?vue&type=template&id=40509477&scoped=true&lang=pug"
import script from "./VEmployer.vue?vue&type=script&lang=ts"
export * from "./VEmployer.vue?vue&type=script&lang=ts"
import style0 from "./VEmployer.vue?vue&type=style&index=0&id=40509477&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40509477",
  null
  
)

export default component.exports